import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import AppAppBar from '../../components/layout/AppAppBar';
import congratulationsGif from '../../assets/Congratulations_20260102065157.gif';
import { Helmet } from 'react-helmet-async';

// Add global definition
declare global {
  interface Window {
    gtag: (
      cmd: string,
      action: string,
      params?: {
        event_category?: string;
        event_label?: string;
        page_location?: string;
        [key: string]: any;
      }
    ) => void;
  }
}

export default function PaymentSuccessPage() {
  const isLoggedIn = !!(localStorage.getItem('user_data') || localStorage.getItem('profile') || localStorage.getItem('is_logged_in'));

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fff' }}>
      {/* Common Navbar */}
      <AppAppBar mode="light" toggleColorMode={() => { }} simpleNavbar={true} transparentMode={true} showProfile={isLoggedIn} showLogin={false} />

      <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', minHeight: 'calc(100vh - 60px)', bgcolor: '#fff', pt: 11 }}>
        <Typography
          variant="h4"
          sx={{
            mb: 4,
            fontWeight: 800,
            fontFamily: 'General-Sans-bold',
            color: '#000',
            position: 'relative',
            display: 'inline-block',
            zIndex: 1
          }}
        >
          Payment Status
          <Box
            sx={{
              position: 'absolute',
              bottom: '6px',
              right: '-5px',
              width: '60%',
              height: '14px',
              bgcolor: '#FFC107',
              zIndex: -1,
              borderRadius: '20px'
            }}
          />
        </Typography>

        {/* Congratulations GIF */}
        <Box sx={{ width: 280, height: 280, mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img
            src={congratulationsGif}
            data-track="gif"
            data-name="payment_success_celebration"
            alt="Congratulations"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          />
        </Box>

        {/* Dynamic Content based on Login Status */}
        {(() => {
          return (
            <>
              <Typography variant="h6" sx={{ color: '#3F51B5', fontWeight: 700, mb: 1, fontFamily: 'General-Sans-bold', textAlign: 'center', fontSize: '1.5rem' }}>
                {isLoggedIn ? "Your payment has been processed" : "Congratulations"}
              </Typography>

              <Typography variant="body2" sx={{ textAlign: 'center', color: '#757575', maxWidth: 320, mb: 4, fontSize: '14px', fontWeight: 500 }}>
                Note: Wait for 24 hours to recieve your payment.
              </Typography>

              <Button
                variant="contained"
                onClick={() => {
                  window.location.href = '/#offers-section';
                }}
                sx={{
                  backgroundColor: '#FFD54F',
                  color: '#000',
                  fontWeight: 800,
                  textTransform: 'none',
                  borderRadius: '24px',
                  px: 4,
                  py: 1.2,
                  fontSize: '1rem',
                  fontFamily: 'General-Sans-bold',
                  boxShadow: '0 4px 12px rgba(255,193,7,0.2)',
                  "&:hover": {
                    backgroundColor: '#FFC107',
                    boxShadow: '0 6px 16px rgba(255, 193, 7, 0.4)',
                  }
                }}
              >
                Explore More Offers
              </Button>
            </>
          );
        })()}

      </Container>
      <Helmet>
        {/* Meta Pixel - Track Lead Event */}
        <script>
          {`fbq('track', 'Lead');`}
        </script>
        {/* End Meta Pixel */}
      </Helmet>
    </Box>
  );
}